
<template>
  <div
    @dragenter.prevent="toggleActive"
    @dragleave.prevent="toggleActive"
    @dragover.prevent
    @drop.prevent="toggleActive"
    :class="{ 'active-dropzone': active }"
    class="dropzone position-relative"
  >
    <div>
      <i class="display-4 text-muted ri-upload-cloud-2-fill"></i>
    </div>

    <div class="text-center">
      <h5>{{ fileInfo.title }}</h5>
      <div class="text-muted" v-if="fileInfo.accept">
        <div v-if="fileInfo.accept == title2 || fileInfo.accept == title1">
          {{fileInfo.accept}}，<a style="z-index: 999;border-bottom: 1px #405189 solid" href="https://fs.iiot-prd.gdnash.com.cn/public/templates/%E5%8E%86%E5%8F%B2%E7%94%B5%E6%B5%81%E6%95%B0%E6%8D%AE%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx">{{ $t("点击下载") }}</a> {{ $t('menu.equipment-management.ObtainTheDeviceTemplate') }}
        </div>
        <div v-else>
          {{this.$t('also.support')}}{{ fileInfo.accept }}
        </div>

      </div>
      <div class="text-muted" v-if="fileInfo.limit">
        {{this.$t('also.FileSizeDoesNotExceed')}}{{ fileInfo.limit }}
      </div>
    </div>

    <label
      :for="ID"
      class="bg-primary text-white stretched-link"
      style="border-radius: 0.25rem"
      >{{this.$t('also.ClickUpload')}}</label
    >
    <input
      :disabled="disabled_type"
      type="file"
      :id="ID"
      class="dropzoneFile btn btn-primary"
      :accept="accepts"
    />
  </div>
</template>


<script>
import { ref } from "vue";
export default {
  name: "dropzone",
  props: {
    accept: {
      type: String,
      default: "*",
    },
    ID: {
      type: String,
      default: "dropzoneFile",
    },
    fileInfo: {
      type: Object,
      default: () => {
        return {
          title: this.$t('page.files_upload.click_upload_pictures_videos_documents'),
          accept: "PPT、PDF、EXCEL、WORD、PNG、JPEG、MP4、MOV",
          limit: "50M",
        };
      },
    },
    disabled_type:{
      type: Boolean,
      default: () => {
        return false;
      },
    }
  },
  computed: {
    accepts() {
      return this.accept;
    },
  },
  data(){
    return{
      title1: this.$t("技改前数据请上传一个自然年数据"),
      title2: this.$t("建议按照年度上传历史电流数据进行分析对比"),
    }
  },
  setup() {
    const active = ref(false);
    const toggleActive = () => {
      active.value = !active.value;
    };
    return { active, toggleActive };
  },
};
</script>